import React, { useState } from 'react'
import { FormikHelpers } from 'formik'

import api from 'common/api'
import Title from 'components/Title'
import EmailForm, { EmailFormValues } from 'components/EmailForm'
import ErrorBox from 'components/ErrorBox'

const ForgotPassword = () => {
  const [emailSent, setEmailSent] = useState(false)
  const [error, setError] = useState(false)

  const handleResetPassword = (values: EmailFormValues, props: FormikHelpers<EmailFormValues>) => {
    setError(false)
    props.setSubmitting(true)
    api
      .post('/api/user/password/reset/request', {
        Email: values.email,
      })
      .then(() => {
        setEmailSent(true)
      })
      .catch(() => {
        setError(true)
        props.setSubmitting(false)
      })
  }

  if (emailSent) {
    return (
      <Title
        title="Check your email 📬"
        subtitle={
          'Your password reset request has been received. If an account matching the provided information is found, an email with further instructions will be sent.'
        }
      />
    )
  }
  return (
    <>
      {error && <ErrorBox error={<>{`Unable to reset your password, please try again later.`}</>} />}
      <Title
        title="Reset your password 🔑"
        subtitle="Please enter your email to receive a reset link."
      />
      <EmailForm
        initialValue={{
          email: '',
        }}
        handleSubmit={handleResetPassword}
        submitText="Send Link"
      />
    </>
  )
}

export default ForgotPassword
